import axios from 'axios'

const localRequest = axios.create({
  baseURL: 'https://api-std.staging.pluginlive.com',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export default localRequest
